const debug = (value, useDir = false) => {
  if(typeof window === 'undefined') console.log(`logging from: ${__dirname}`);
  console.log('----------------------------------------- debug -----------------------------------------');

  if (useDir) return console.dir(value, { depth: 6 });

  const keys = Object.keys(value);
  keys.forEach(key => {
    console.log(`${key}:`, value[key]);
  });
};

export default debug;
